import React, { useState } from "react";
import classes from "./StatisticModal.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Row, Col } from "react-bootstrap";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { CancelredIcon } from "../../../../../constant/imagePath";
import ReactApexChart from "react-apexcharts";

const StatisticModal = ({ show, setShow }) => {
  const [sports, setSports] = useState();
  const [seasons, setSeasons] = useState();
  const [location, setLocation] = useState();

  const sportsData = [
    { label: "Tennis", value: "Tennis" },
    { label: "Soccer", value: "Soccer" },
    { label: "Skating", value: "Skating" },
    { label: "Baseball", value: "Baseball" },
  ];

  const seasonData = [
    { label: "All", value: "All" },
    { label: "Summer", value: "Summer" },
    { label: "Winter", value: "Winter" },
    { label: "Spring", value: "Spring" },
    { label: "Autumn", value: "Autumn" },
  ];

  const locationData = [
    { label: "All", value: "All" },
    { label: "Royal Tennis Court", value: "Royal Tennis Court" },
    { label: "Green Tennis Court", value: "Green Tennis Court" },
  ];

  const series = [
    {
      name: "Summer",
      data: [301, 390, 280, 310, 340, 109, 110, 320, 205, 320, 340, 222, 340],
      color: `${Colors.errorColor}`,
    },
    {
      name: "Autumn",
      data: [100, 200, 124],
      color: `${Colors.neutralShadesOfGainsboro}`,
    },

    {
      name: "Winter",
      data: [110, 320, 245, 320, 304, 352, 241, 331, 140, 280, 251, 142, 109],
      color: `${Colors.mainBlue}`,
    },
    {
      name: "Spring",
      data: [150, 250, 1],
      color: `${Colors.neutralShadesOfGainsboro}`,
    },

  ];

  const options = {
    chart: {
      height: 350,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "string",
      categories: [
        "<$.5k",
        "$0.5k+",
        "$1k+",
        "$1.5+",
        "$2k+",
        "$2.5k+",
        "$3k+",
        "$3.5k+",
        "$4k+",
        "$4.5k+",
        "$5k+",
        "$5.5k+",
        "$6k+",
      ],
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          return `${value}`;
        },
      },
      min: 0,
      max: 400,
      tickAmount: 4,
    },
    // tooltip: {
    //   x: {
    //     format: "dd/MM/yy HH:mm",
    //   },
    // },
  };
  return (
    <>
      <style>{`
              @media screen and (max-width: 992px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
        .${modalClasses.header}{
            margin:32px;
        }
        .${modalClasses.body}{
            padding:0px 32px 32px 32px;
        }
        .${classes.apexarea}  .apexcharts-toolbar {
          display:none !important;
        }
        .${classes.apexarea} .apexcharts-legend-marker {
          border-radius: 0px !important;
          margin: 0px 6px;
        }
        .${classes.apexarea} .apexcharts-legend-series {
          margin: 12px 24px !important;
        }
        

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: "32px",
        }}
        borderRadius={"20px"}
        width={"956px"}
        header={
          <div>
            <h4
              style={{
                ...Fonts.h4f26,
                color: Colors.neutralShadesOfNero,
              }}
              className={[classes.mb8].join(" ")}
            >
              Seasons statistic
            </h4>
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
              The{" "}
              <span style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}>
                number of coaches
              </span>{" "}
              is shown on the left side of the chart, and the bottom line shows
              the profit for the current season as an indicator of demand. 6k+
              includes coaches with income $6000 and more.
            </p>
          </div>
        }
      >
        <div>
          <Row className={[classes.mb40].join(" ")}>
            <Col md={4}>
              <DropDown
                placeholder="Sports"
                state={sports}
                setter={setSports}
                options={sportsData}
              />
            </Col>
            <Col md={4}>
              <DropDown
                placeholder="Season"
                state={seasons}
                setter={setSeasons}
                options={seasonData}
              />
            </Col>
            <Col md={4}>
              <DropDown
                placeholder="Location"
                state={location}
                setter={setLocation}
                options={locationData}
              />
            </Col>
          </Row>

          <ReactApexChart
            options={options}
            series={series}
            type="area"
            height={600}
            className={[classes.apexarea].join(" ")}
          />
        </div>
      </ModalSkeleton>
    </>
  );
};
export default StatisticModal;
